export const containerLeft = {
  alignItems: 'center',
  bottom: 95,
  display: 'flex',
  left: 21,
  position: 'absolute',
  top: 80,
  width: '40%',
  zIndex: 1,
}

export const containerRight = {
  alignItems: 'center',
  bottom: 95,
  display: 'flex',
  position: 'absolute',
  right: 21,
  top: 80,
  width: '40%',
  zIndex: 1,
}

export const iconHidden = {
  visibility: 'hidden',
}

export const iconVisible = {
  visibility: 'visible',
}

export const aRight = {
  marginLeft: 'auto',
}
